import { CSSProperties } from 'react';
import { ApiDownloadButton } from 'components/common';
import { CourseQRCode, CourseShareCode } from 'components/courses/common';
import { useReduxState } from 'hooks';
import { breakpoints } from 'styles';
import { Link } from 'components/common';

import type { PageState } from 'types';

interface Props {
  course: PageState['course'] | PageState['readerCourseData']['course'];
  isReader?: boolean;
  showDownloadButton?: boolean;
  style?: CSSProperties;
  usePrintStyles?: boolean;
}

const CourseShare = ({
  course,
  isReader,
  showDownloadButton,
  style,
  usePrintStyles
}: Props) => {
  const { messages, serverConfig, theme } = useReduxState();

  return (
    <div className="share" style={style}>
      {serverConfig.courseEnableShareQRCode ? (
        <>
          <div className="qr-code qr-code-smaller">
            <CourseQRCode course={course} size={168} />
          </div>
          <div className="qr-code qr-code-larger">
            <CourseQRCode course={course} />
          </div>
        </>
      ) : null}

      <div className="info">
        <div className="title">{course?.title}</div>

        <div className="link">
          <Link
            href={`${serverConfig.adminUrl}/courses/${course.slug}`}
            text={`${serverConfig.adminUrl.replace(
              /https?:\/\//,
              ''
            )}/courses/${course.slug}`}
          />
        </div>

        {serverConfig.courseEnableShareCode ? (
          <div className="share-code">
            <CourseShareCode
              course={course}
              isReader={isReader}
              style={{ marginTop: 25 }}
            />
          </div>
        ) : null}

        {showDownloadButton ? (
          <div className="download">
            <ApiDownloadButton
              category="light"
              filename={`${course?.slug}.pdf`}
              icon="file-pdf"
              text={messages.commonDownloadPdf}
              url={`/admin/courses/${course?.id}/share-info`}
            />
          </div>
        ) : null}
      </div>

      <style jsx>{`
        .share {
          background-color: ${theme.lightGreyLighter};
          border-radius: 7px;
          color: ${theme.textColorLight};
          display: flex;
          flex-wrap: wrap;
          padding: 30px;
          text-align: center;
        }
        .info {
          flex-grow: 1;
          padding: 20px 0;
          margin-top: 15px;
          width: 100%;
        }
        .title {
          font-size: 2rem;
          font-weight: 700;
        }
        .link {
          font-size: 1.8rem;
          margin-top: 10px;
        }
        .download {
          margin-top: 40px;
        }
        .qr-code {
          width: 100%;
        }
        .qr-code-smaller {
          display: block;
        }
        .qr-code-larger {
          display: none;
        }
        @media (min-width: ${usePrintStyles
            ? breakpoints.small
            : breakpoints.medium}px) {
          .share {
            flex-direction: row-reverse;
            flex-wrap: nowrap;
            text-align: left;
          }
          .qr-code {
            width: auto;
          }
          .qr-code-smaller {
            display: none;
          }
          .qr-code-larger {
            display: block;
          }
          .info {
            margin-top: 0;
            margin-right: 50px;
            width: auto;
          }
        }
      `}</style>
    </div>
  );
};

export default CourseShare;
